export const NATIVE_TRANSACTION_QUERY_PARAM = 'native_transaction'
export const NATIVE_APP_QUERY_PARAM = 'native_app'
export const NATIVE_TRANSACTION_STORAGE_KEY =
  '3dmeet.native-meeting-transaction.v1'

const OPAQUE_VALUE_PATTERN = /^[A-Za-z0-9_-]{43}$/
const NATIVE_TRANSACTION_TTL_MS = 10 * 60 * 1000
const CALLBACK_BY_SITE_ORIGIN = {
  'https://www.3dmeet.com': 'com.threedmeet.app://native/meeting',
  'https://staging.3dmeet.com': 'com.threedmeet.appdev://native/meeting',
}

const validTransaction = (value) =>
  typeof value === 'string' && OPAQUE_VALUE_PATTERN.test(value)

const readStoredTransaction = (storage, now) => {
  try {
    const raw = storage.getItem(NATIVE_TRANSACTION_STORAGE_KEY)
    if (!raw) return { status: 'none', transaction: null }
    const stored = JSON.parse(raw || 'null')
    if (
      !stored ||
      !validTransaction(stored.transaction) ||
      typeof stored.createdAt !== 'number' ||
      now - stored.createdAt < 0 ||
      now - stored.createdAt > NATIVE_TRANSACTION_TTL_MS
    ) {
      storage.removeItem(NATIVE_TRANSACTION_STORAGE_KEY)
      return { status: 'expired', transaction: null }
    }
    return { status: 'ready', transaction: stored.transaction }
  } catch (_error) {
    return { status: 'invalid', transaction: null }
  }
}

export const readNativeMeetingRequest = (search, storage, now = Date.now()) => {
  const params = new URLSearchParams(search || '')
  const requested = params.get(NATIVE_APP_QUERY_PARAM) === '1'
  const fromUrl = params.get(NATIVE_TRANSACTION_QUERY_PARAM)

  if (requested) {
    if (!validTransaction(fromUrl)) {
      clearNativeMeetingTransaction(storage)
      return { status: 'invalid', transaction: null }
    }
    try {
      storage.setItem(
        NATIVE_TRANSACTION_STORAGE_KEY,
        JSON.stringify({ transaction: fromUrl, createdAt: now }),
      )
    } catch (_error) {
      // Storage can be unavailable in locked-down browser sessions. The
      // current account page can still complete using the URL value.
    }
    return { status: 'ready', transaction: fromUrl }
  }

  return readStoredTransaction(storage, now)
}

export const clearNativeMeetingTransaction = (storage) => {
  try {
    storage.removeItem(NATIVE_TRANSACTION_STORAGE_KEY)
  } catch (_error) {
    // Best-effort cleanup after a successful single-use handoff.
  }
}

export const isValidNativeMeetingCallback = (value, siteOrigin) => {
  if (typeof value !== 'string' || value.length > 512) return false
  const expected = CALLBACK_BY_SITE_ORIGIN[siteOrigin]
  if (!expected) return false
  try {
    const parsed = new URL(value)
    const expectedUrl = new URL(expected)
    return (
      parsed.protocol === expectedUrl.protocol &&
      parsed.hostname === expectedUrl.hostname &&
      parsed.pathname === expectedUrl.pathname &&
      !parsed.port &&
      !parsed.username &&
      !parsed.password &&
      !parsed.hash &&
      parsed.searchParams.getAll('code').length === 1 &&
      parsed.searchParams.getAll('state').length === 1 &&
      !Array.from(parsed.searchParams.keys()).some(
        (key) => key !== 'code' && key !== 'state',
      ) &&
      OPAQUE_VALUE_PATTERN.test(parsed.searchParams.get('code') || '') &&
      OPAQUE_VALUE_PATTERN.test(parsed.searchParams.get('state') || '') &&
      !parsed.searchParams.has('token')
    )
  } catch (_error) {
    return false
  }
}

export const removeNativeMeetingQuery = (url, history) => {
  const parsed = new URL(url)
  parsed.searchParams.delete(NATIVE_APP_QUERY_PARAM)
  parsed.searchParams.delete(NATIVE_TRANSACTION_QUERY_PARAM)
  history.replaceState(
    {},
    '',
    `${parsed.pathname}${parsed.search}${parsed.hash}`,
  )
}
